<template>
    <!--    <form @submit.prevent>-->
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class='top-title-content'>
            <span class='title'>터치모니터 설정</span>
            <span class='txt'
            >회원이 출석 체크를 하는 터치모니터의 화면 전환 및 입장 후 자동 퇴실시간 적용 등 터치모니터를 이용한
                출석체크 관련 내용을 설정합니다.</span
            >
        </div>

        <div class='com-table-wrap'>
            <div class='com-card-input half-type full'>
                <div class='left-box full'>
                    <span class='top-title'>센터 입장 이용권 권한 설정</span>
                    <div class='line'>
                        <span class='tit'>OT, 개인, 듀엣, 그룹 등 레슨 이용권의 입장권 권한 여부를 설정합니다.</span>
                        <div class='input-cnt'>
                            <div class='com-radio'>
                                <input
                                    id='radio-1-1'
                                    v-model='data.noReservationEnterYn'
                                    name='radio-1'
                                    required
                                    type='radio'
                                    value='true'
                                />
                                <label for='radio-1-1'
                                >당일에 예약된 내역이 없다면 <span class='red'>입장불가능</span> 합니다.</label
                                >
                            </div>
                        </div>
                        <div class='input-cnt'>
                            <div class='com-radio'>
                                <input
                                    id='radio-1-2'
                                    v-model='data.noReservationEnterYn'
                                    name='radio-1'
                                    required
                                    type='radio'
                                    value='false'
                                />
                                <label for='radio-1-2'
                                >당일에 예약된 내역이 없어도<span class='green'>입장가능</span> 합니다.</label
                                >
                            </div>
                        </div>
                    </div>

        
                    <span class='top-title'>센터 입장 이용권 일일제한 설정</span>
                    <div class='line'>
                        <span class='tit'>이용권의 센터 입장 제한 여부를 설정합니다.</span>
                        <div class='input-cnt'>
                            <div class='com-radio'>
                                <input
                                    id='radio-3-1'
                                    v-model='data.dailyEntryLimitYn '
                                    name='radio-3'
                                    required
                                    type='radio'
                                    value='true'
                                />
                                <label for='radio-3-1'
                                >이용권당 일일 방문 횟수를 1회로 제한합니다. (재입장 불가)</label
                                >
                            </div>
                        </div>
                        <div class='input-cnt'>
                            <div class='com-radio'>
                                <input
                                    id='radio-3-2'
                                    v-model='data.dailyEntryLimitYn'
                                    name='radio-3'
                                    required
                                    type='radio'
                                    value='false'
                                />
                                <label for='radio-3-2'
                                >일일 입장 횟수에 제한없이 센터 입장이 가능합니다. </label
                                >
                            </div>
                        </div>
                    </div>
                    <span class='top-title'>출석/입장 알림 팝업 설정</span>
                    <div class='line'>
                        <span class='tit'>출석/입장하는 회원 정보를 사이트 우측 하단에 5초간 노출하는 알림 팝업 여부를 설정합니다.</span>
                        <div class='input-cnt'>
                            <div class='com-radio'>
                                <input
                                    id='radio-2-1'
                                    v-model='data.openCardYn'
                                    name='radio-2'
                                    required
                                    type='radio'
                                    value='true'
                                />
                                <label for='radio-2-1'>사용</label>
                            </div>
                        </div>
                        <div class='input-cnt'>
                            <div class='com-radio'>
                                <input
                                    id='radio-2-2'
                                    v-model='data.openCardYn'
                                    name='radio-2'
                                    required
                                    type='radio'
                                    value='false'
                                />
                                <label for='radio-2-2'>미사용</label>
                            </div>
                        </div>
                    </div>

                    <span class='top-title'>출석/입장 알림음 설정</span>
                    <div class='line'>
                        <span class='tit'>회원이 출석/입장하는 경우 센터가 설정한 안내음을 송출합니다.</span>
                        <div class='input-cnt'>
                            <div class='select-row'>
                                <select-form
                                    :select-data="['음소거(기본)', '음성 안내멘트', '멜로디']"
                                    :select-value="['N', 'S', 'M']"
                                    :selected-value="data.soundOption"
                                    @update:set='updateSoundOption'
                                ></select-form>
                                <select-form
                                    v-if="data.soundOption != 'N'"
                                    :select-data="['안내음 송출화면', '관리자 화면', '터치출석 화면', '관리자,터치화면']"
                                    :select-value="['N', 'A', 'T', 'B']"
                                    :selected-value="data.soundFrom"
                                    @update:set='updateSoundFrom'
                                ></select-form>
                                <div v-if="data.soundOption === 'S' || data.soundOption === 'M'" class='right'>
                                    <div class='txt'>
                                        <label>・ 출석/입장 성공</label>
                                        <button @click="playAudio('T')" class='sound-icon'></button>
                                    </div>
                                    <div class='txt'>
                                        <label>・ 출석/입장 불가</label>
                                        <button @click="playAudio('F')" class='sound-icon'></button>
                                    </div>
                                    <div class='txt'>
                                        <label>・ 이용권 만료 7일, 횟수 3회 이하</label>
                                        <button @click="playAudio('E')" class='sound-icon'></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <span class='top-title'>센터 공지 문구 설정
                        <span class='right-txt blue'
                        >* 공백 포함 최대 30자 국문, 영문, 숫자, 특수문자 입력 가능</span
                        ></span
                    </span>
                    <div class='line'>
                        <span class='tit'>터치출석 화면 상단에 센터가 설정한 문구를 설정합니다. 미입력 시 기본 문구가 노출됩니다.</span>
                        <div class='input-cnt'>
                            <input
                                v-model='data.headerMessage'
                                @input='validateHeaderMessage'
                                class='w640'
                                type='text'
                                placeholder='센터 입장을 위해 회원번호를 입력해주세요.'
                            />
                        </div>
                    </div>

                    <span class='top-title'
                    >터치화면에 센터 이미지를 등록하시겠습니까? (최대 5개)
                        <span class='right-txt blue'
                        >* 용량 제한 : 10MB 이하</span
                        ></span
                    >
                    <div class='line'>
                        <span class='tit'>회원번호를 입력하는 터치패드 화면에서 센터 이미지를 보여줍니다.</span>
                        <div class='input-cnt'>
                            <div class='com-file-single preview'>
                                <!-- 첨부 완료시 -->
                                <span v-for='(image, index) in images' :key="'image' + index" class='complete-img'>
                                    <img
                                        :src="
                                            typeof image === 'object'
                                                ? 'data:image/jpeg;base64,' + image.base64data
                                                : image
                                        "
                                        alt=''
                                    />
                                    <button class='del-btn' type='button' @click='removeImage(index)'>
                                        <span class='blind'>삭제하기</span>
                                    </button>
                                </span>
                                <!-- //첨부 완료시 -->
                                <template v-if='images.length < 5'>
                                    <b-form-file id='file1' v-model='file' accept='image/jpeg' plain></b-form-file>
                                    <label class='preview' for='file1'></label>
                                    <!-- <label for="file1" class="white-btn">+ 추가</label> -->
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <loading-spinner v-if='isLoading'></loading-spinner>
                <div v-else class='bottom-btn'>
                    <button class='com-btn' type='reset'>취소</button>
                    <button class='com-btn blue' type='button' @click='save'>수정</button>
                </div>
            </div>
        </div>
    </div>
    <!--    </form>-->
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingTouch',
    props: {},
    components: { LoadingSpinner },
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            isLoading: false,
            images: [],
            file: null,
            data: {
                noReservationEnterYn: true, //기본값
                openCardYn: true,
                headerMessage: '',
                soundOption: 'N',
                soundFrom: 'N',
                //autoExitHour:2,
                //showCustomerInfoYn:false,
            },
        };
    },
    mounted() {
        this.load();
    },
    watch: {
        async file(file) {
            if (file === null) return;
            let base64data = await this.readFileAsync(file);
            base64data = base64data.split(',')[1];
            if (base64data === undefined) {
                alert('비어있는 파일은 첨부할 수 없습니다.');
                this.file = null;
                return;
            }
            const fileInfo = {
                filename: file.name,
                mimetype: file.type,
                base64data: base64data,
            };
            this.images.push(fileInfo);
            this.file = null;
        },
    },
    methods: {
        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        load() {
            this.isLoading = true;
            this.images = [];
            // 스웨거 검색: 센터 터치모니터 설정 조회
            api.get(`/admin/api/centerTouchMonitorSetting/${this.centerId}`)
                .then(res => {
                    this.isLoading = false;
                    this.data = res.data || {};

                    console.log ('centerTouchMonitorSetting');
                    console.log (this.data);
                    [1, 2, 3, 4, 5].forEach(i => {
                        if (String(res.data[`centerImage${i}`]).search(/^(http|\/)/) >= 0) {
                            this.images.push(res.data[`centerImage${i}`]);
                            res.data[`centerImage${i}`] = null;
                        }
                    });
                })
                .catch(res => {
                    this.isLoading = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        save() {
            this.isLoading = true;
            let data = {
                centerId: this.centerId,
                ...this.data,
            };
            this.images.forEach((o, i) => {
                if (typeof o == 'object') {
                    data[`centerImage${i + 1}`] = o;
                } else {
                    delete data[`centerImage${i + 1}`];
                }
            });
            console.log(data);
            (this.data.centerId
                    ? api.put('/admin/api/centerTouchMonitorSetting/update', data)
                    : api.post('/admin/api/centerTouchMonitorSetting/create', data)
            )
                .then(res => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                    this.load();
                })
                .catch(res => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        removeImage(index) {
            if (confirm('삭제하시겠습니까?')) {
                // if (typeof this.data[`centerImage${index}`] == 'string') {
                //     this.images.splice(index, 1);
                // }
                // else {
                this.isLoading = true;
                api.delete(`/admin/api/centerTouchMonitorSetting/${this.centerId}/${index + 1}`)
                    .then(res => {
                            this.isLoading = false;
                            this.images.splice(index, 1);
                        },
                    )
                    .catch(res => {
                        this.isLoading = false;
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                        console.error(res);
                    });
                // }
            }
            console.log(this.data);
        },
        validateHeaderMessage(event) {
            let filteredValue = event.target.value.replace(/[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\s]/g, '');
            // 30자 이상의 문자열은 잘라냄
            if (filteredValue.length > 30) {
                filteredValue = filteredValue.slice(0, 30);
            }
            // 입력 필드의 값을 업데이트
            this.data.headerMessage = filteredValue;
        },
        updateSoundOption(val) {
            this.$set(this.data, 'soundOption', val);
            // 음소거 일때 송출화면 제거
            if( val == 'N' ) {
                this.$set(this.data, 'soundFrom', 'N');
            }
        },
        updateSoundFrom(val) {
            this.$set(this.data, 'soundFrom', val);
        },
        playAudio(soundType) {
            if( this.data.soundOption === 'M' ) {
                let audio = null;
                if( soundType === 'T' ) {
                    audio = new Audio('/audio/attendance_entrance.mp3');
                }else if( soundType === 'F' ) {
                    audio = new Audio('/audio/invalid_attendance_entrance.mp3');
                }else if( soundType === 'E' ) {
                    audio = new Audio('/audio/expiring_attendance_entrance.mp3');
                }
                audio.play().catch(error => {
                    console.error('Audio playback failed:', error);
                });
            }else if( this.data.soundOption === 'S' ) {
                if( soundType === 'T' ) {
                    this.speak("출석 완료 되었습니다.");
                }else if( soundType === 'F' ) {
                    this.speak("예약 된 수업이 없습니다.");
                }else if( soundType === 'E' ) {
                    this.speak("출석 완료 되었습니다. 이용권이 곧 종료 예정입니다.");
                }
            }
        },
        speak(text) {
            console.log("speak: ", text);
            try {
                const utterance = new SpeechSynthesisUtterance(text);
                window.speechSynthesis.speak(utterance);
            } catch (e) {
                console.error(e);
            }
        },
    },
};
</script>
<style lang='scss' scoped>
.spinner-container {
    height: 242px;
}

.com-file-single {
    display: flex !important;

    .complete-img {
        z-index: 2;
        min-width: 180px;
        margin-right: 20px;
        background: #fff;
        background-image: none !important;
        border: 1px dashed #c3c3c3;
    }

    .preview {
        margin-top: 0 !important;
        min-width: 180px;
    }
}

.select-row {
    display: flex;
    align-items: center;
    gap: 32px;

    .right {
        display: flex;
        gap: 32px;

        .txt {
            display: flex;
            align-items: center;
            gap: 10px;
            font-family: Noto Sans CJK KR;
            font-size: 13px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.6000000238418579px;
            text-align: left;
            color: #444040;
        }
    }
}

.sound-icon {
    width: 24px;
    height: 24px;
    background: url(/img/icons/touch_sound.png) no-repeat;
    background-position: center !important;
}
</style>
